function headingReveal(obsclass) {
    const observerOptions = {
        root: null,
        threshold: 0.2  // Adjust as needed
      };
    
      const revealCallback = function(entries, observer) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal');
            observer.unobserve(entry.target); // Remove observer after revealing
          }
        });
      };
    
      const observer = new IntersectionObserver(revealCallback, observerOptions);
      const accentSubheadings = document.querySelectorAll(obsclass);
    
      accentSubheadings.forEach(el => {
        observer.observe(el);
      });
}